import createStaffListWidget from './createStaffListWidget';
export default ({ editorAPI }: AnyFixMe) =>
  createStaffListWidget({
    editorAPI,
  });
